import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function PwaRouteTransition({ children }) {
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    let timeoutId;
    setIsTransitioning(true);
    timeoutId = setTimeout(() => setIsTransitioning(false), 320);
    if (window.matchMedia('(display-mode: standalone)').matches) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search]);

  const skeletonClass = useMemo(() => {
    if (location.pathname.startsWith('/products')) return 'pwa-skeleton--grid';
    if (location.pathname.startsWith('/orders')) return 'pwa-skeleton--list';
    if (location.pathname.startsWith('/profile')) return 'pwa-skeleton--profile';
    return 'pwa-skeleton--home';
  }, [location.pathname]);

  return (
    <div className="pwa-page">
      {isTransitioning && (
        <div className="pwa-page__skeleton" aria-hidden="true">
          <div className={`pwa-skeleton ${skeletonClass}`} />
        </div>
      )}
      <div className={`pwa-page__content${isTransitioning ? ' is-transitioning' : ''}`}>
        {children}
      </div>
    </div>
  );
}
